export default "__VITE_ASSET__7ae8db27__"